import React, { useEffect, useContext, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import VariableContext from 'context/variable/variableContext';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { VarName } from "types/variable/index"

const useStyles = makeStyles((theme) => ({
    formControl: {
      width: "100%",
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));

function SelectorSilobolsa({dispositivoElegido , func}) {
    const classes = useStyles();

    const variableContext = useContext(VariableContext);
    const { obtenerVariables } = variableContext;
    const [ variables, setVariables] = useState([])
    const [ state, setState ] = useState()
    //25% bateria baja
    useEffect(() => {    
        obtenerVariables(dispositivoElegido.id).then(
            value =>{
                setVariables(value.data?value.data:[])
                console.log({variables:value.data?value.data:[]})
            }
        )   
        // eslint-disable-next-line
    }, [dispositivoElegido]);
    
    const handleChange = (event) => {
        const a = event.target.value
        setState(a)        
        func(a);
      };
    //console.log("var => " ,state)
    return (
        <div>
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel id="variables">Alerta</InputLabel>
        { variables ?
          <Select
            labelId="variables"
            id="variables"
            value={state?state:""}
            onChange={handleChange}
            label="variables"
          >
              {variables.length === 0 ?
                <MenuItem value="">
                  <em>Dispositivo sin variables creadas</em>
                </MenuItem>
                : 
                variables.map((variable) => {
    
                   if (variable.referenciaNodo.toLowerCase() === VarName.Bateria.toLowerCase()){
                        return <MenuItem key={variable.id} value={variable}>Bateria baja</MenuItem>
                   }

                   if (variable.referenciaNodo.toLowerCase() === VarName.Movimiento.toLowerCase()){
                    return <MenuItem key={variable.id} value={variable}>Detecta movimiento</MenuItem>
                   }
                  
                   return null;                    
                })}
          </Select>
        :
        <Select
            disabled
            labelId="grupo"
            id="grupo"
            label="grupo"
          >
          </Select>
      }
      </FormControl>

    </div>
    )
}

export default SelectorSilobolsa
